import { mainAPI, handleApiError } from "../api";

import {
  AuthResponse,
  RefreshTokenRequest,
  UserPasswordRequest,
  RefreshTokenResponse,
} from "../types/api/auth";
import { ApiErrorResponse } from "../types/api/error";

const path = `auth/${process.env.REACT_APP_API_VERSION}/admin`;

// Auth - Вход по почте и паролю
export function authWithUsernamePassword(credentials: UserPasswordRequest) {
  return mainAPI
    .post<AuthResponse>(`${path}/login`, credentials, {
      skipErrorHandling: true,
      metadata: { addCountry: false },
    })
    .then(
      (res) => {
        const { accessToken, refreshToken, totpRequired, temporaryToken } =
          res.data;
        return Promise.resolve({
          accessToken,
          refreshToken,
          totpRequired,
          temporaryToken,
        });
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        const errorMessage =
          apiError?.errors?.error || apiError?.detail || "Произошла ошибка";

        const customError: any = new Error(errorMessage);
        customError.status = error.response?.status;
        return Promise.reject(customError);
      }
    );
}

// Auth - Обновить токены доступа
export function refreshJWT(refresh: RefreshTokenRequest) {
  const url = `auth/${process.env.REACT_APP_API_VERSION}`;

  return mainAPI
    .post<RefreshTokenResponse>(`${url}/jwt_refresh`, refresh, {
      metadata: { addCountry: false },
    })
    .then(
      (res) => {
        const { accessToken, refreshToken } = res.data;
        return Promise.resolve({
          accessToken,
          refreshToken,
        });
      },
      (error) => handleApiError(error)
    );
}

// Auth - Выход из системы
export function logout(refresh: RefreshTokenRequest) {
  return mainAPI
    .post(`${path}/logout`, refresh, { metadata: { addCountry: false } })
    .then(
      (res) => {
        return Promise.resolve();
      },
      (error) => handleApiError(error)
    );
}
